import * as $ from 'jquery';
import 'jquery-migrate';

declare global {
	interface Window {
		jQuery: JQueryStatic;
	}
}

window.jQuery = $;
export default $;